import { cruduex } from './utils';

import httpClient from '@/utils/httpClient';

export default {
  namespaced: true,
  ...cruduex('reports', {
    async getById(id) {
      return httpClient.get(`/api/reports/${id}`);
    },
    async getCollection() {
      return httpClient.get('/api/reports/');
    },
    async create(data) {
      return httpClient.post('/api/reports/', data);
    },
    async update(id, data) {
      return httpClient.patch(`/api/reports/${id}`, data);
    },
    async delete(id) {
      return httpClient.delete(`/api/reports/${id}`);
    }
  })
};
